import * as Yup from 'yup';

const requiredMsg = isMobile => (isMobile ? 'Requerido' : 'Campo requerido');

const invalidMsg = isMobile => (isMobile ? 'Inválido' : 'Caracter inválido');

const onlyNumbersMsg = isMobile =>
  isMobile ? 'Solo números' : 'Este campo solo acepta números';

export const billingBookingSchema = ({
  isMobile = false,
  withEntity = false,
  isPointOfSale = false,
} = {}) =>
  Yup.object().shape({
    ownerCardName: Yup.string()
      .required(requiredMsg(isMobile))
      .matches(/^[a-zA-Z\s]+$/, invalidMsg(isMobile)),

    ownerCardLastName: Yup.string()
      .required(requiredMsg(isMobile))
      .matches(/^[a-zA-Z\s]+$/, invalidMsg(isMobile)),

    ownerDocument: Yup.string().required(requiredMsg(isMobile)),

    afip: Yup.string().required(requiredMsg(isMobile)),

    street: Yup.string().required(requiredMsg(isMobile)),

    streetNumber: Yup.string()
      .required(requiredMsg(isMobile))
      .matches(/^[0-9]+$/, onlyNumbersMsg(isMobile)),

    floor: Yup.string().matches(/^[0-9]+$/, onlyNumbersMsg(isMobile)),

    province: Yup.string().required(requiredMsg(isMobile)),

    department: Yup.string(),

    postalCode: Yup.string()
      .required(requiredMsg(isMobile))
      .matches(/^[0-9]+$/, onlyNumbersMsg(isMobile)),

    city: Yup.string()
      .required(requiredMsg(isMobile))
      .matches(/^[a-zA-Z\s]+$/, invalidMsg(isMobile)),

    ...(withEntity && {
      id_entity: Yup.string().test(
        'required-if-pos-and-emit',
        'Debes seleccionar un punto de venta',
        function (value) {
          return isPointOfSale ? !!value : true;
        }
      ),

      id_assigned_seller: Yup.string().test(
        'required-if-seller-and-emit',
        'Debes seleccionar un vendedor',
        function (value) {
          return isPointOfSale ? true : !!value;
        }
      ),
    }),
  });

export default billingBookingSchema;
